import { render, staticRenderFns } from "./phone-mask.vue?vue&type=template&id=8da27da2&"
import script from "./phone-mask.vue?vue&type=script&lang=js&"
export * from "./phone-mask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports